import React, { useState } from "react";
import styles from "./styles.css";
import PropTypes from "prop-types";
import Completed from "./images/completed.svg";
import Download from "./images/download.svg";
import Document from "./images/document.svg";
import { NUMBER } from "../../../constants/app-constants";
import { sendCustomGaEvents } from "../../../tracking";
import { downloadReportClicked } from "./tracking";
import { yieldToMain } from "../../../utils/helpers/yield-to-main";
import { Label } from "@cars24/turbo-web/lib/label";
import { useTokens } from "@cars24/turbo-web/lib/theme-provider";
import LazyImage from "../lazy-image";

const VasDownloadSampleReportV2 = ({
    eventCategory = "",
    fileName = "",
    isMobile = true,
    details = {}
}) => {

    const [showToast, setShowToast] = useState(false);

    const { tokens } = useTokens();

    const handleClick = async () => {
        await yieldToMain();

        if (!showToast) {
            setShowToast(true);
            window.setTimeout(() => {
                setShowToast(false);
            }, NUMBER.TWO_THOUSAND);
        }

        await yieldToMain();
        sendCustomGaEvents({
            ...downloadReportClicked,
            ...(eventCategory && { eventCategory })
        });
    };

    const {title: downloadTitle = "", ctaRedirectUrl: primaryCtaLink = ""} = details || {};

    return (
        <div styleName={isMobile ? "styles.vasDownloadSampleReport" : "styles.vasDownloadSampleReportDesktop"}>
            <a
                target="_blank"
                download={fileName}
                href={primaryCtaLink}
                onClick={handleClick}
            >
                <div styleName={"styles.downloadWrapper"} className="shrinkOnTouch">
                    <div styleName={"styles.downloadTextWrapper"}>
                        <LazyImage src={Document} alt={"document icon"} />
                    </div>
                    <div styleName={"styles.downloadTextIconWrapper"}>
                        <Label level={isMobile ? NUMBER.THREE : NUMBER.FOUR} fontWeight="semibold" color={tokens.text_default_text_primary}>{downloadTitle}</Label>
                        <img src={Download} alt={"download Icon"} />
                    </div>
                </div>
                {showToast &&
                <div styleName={"styles.downlaodInfo"}>
                    <img src={Completed} alt={"Completed"} />
                    Sample Report Downloaded
                </div>
                }
            </a>
        </div>
    );
};

VasDownloadSampleReportV2.propTypes = {
    eventCategory: PropTypes.string,
    fileName: PropTypes.string,
    desktopImg: PropTypes.object,
    mobileImg: PropTypes.object,
    isMobile: PropTypes.bool,
    details: PropTypes.object
};

export default VasDownloadSampleReportV2;

